import styled, { keyframes } from "styled-components";

const wave = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-40px); }
`;

export const CenterWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
`;

export const GaugeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: scale(${props => props.size || 1});
  transform-origin: bottom center;
`;

export const TankLabel = styled.div`
  margin-bottom: 10px;
  font-size: ${({ size }) => (size ? 16 * size : 16)}px;
  font-weight: bold;
`;

export const TankContainer = styled.div`
  width: ${({ size }) => (size ? 80 * size : 80)}px;
  height: ${({ size }) => (size ? 200 * size : 200)}px;
  border: 3px solid #333;
  border-radius: 8px;
  overflow: hidden;
  background: #f0f0f0;
  position: relative;
`;

export const TankBody = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: #fff;
`;

export const Liquid = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: ${({ height }) => height};
  background: #00bfff;
  border-top: 2px solid #0090c0;
  transition: height 1s ease;
  overflow: visible;
`;

export const Wave = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 160px; /* 4 ondas de 40px */
  height: 10px;
  background: repeating-linear-gradient(
    -45deg,
    #00bfff,
    #00bfff 10px,
    #0090c0 10px,
    #0090c0 20px
  );
  animation: ${wave} 2s alternate infinite;
  border-radius: 50% 50% 0 0;
  pointer-events: none;
`;

export const InfoTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  margin-left: 20px;
`;

export const InfoText = styled.div`
  font-size: 14px;
  color: #333;
  font-weight: 500;
`;